//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { required, email } from 'vuelidate/lib/validators';
import form from '~/mixins/components/form';

const localeKey = 'signup';

export default {
  name: 'auth-signup-form',
  mixins: [form],
  props: {
    pending: {
      type: Boolean,
      default: false,
    },
  },
  validations () {
    return {
      request: {
        name: { required },
        email: {
          required,
          email,
        },
        password: { required },
        confirmPassword: { required },
      },
    };
  },
  data () {
    return { localeKey };
  },
  methods: {
    submit () {
      if (this.pending) return;
      // Read autofilled values before the parent validates and sends the request.
      this.request.name = this.$refs.name.getValue();
      this.request.email = this.$refs.email.getValue();
      this.request.password = this.$refs.password.getValue();
      this.request.confirmPassword = this.$refs.confirmPassword.getValue();
      this.$emit('submit');
    },
  },
};
